import { defineComponent as _defineComponent } from 'vue'
import { HomePageCard, homepageCards } from '@@/bits/landside_helper'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from '@@/pinia/dark_mode'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePageWorldwideUsersCard',
  props: {
    width: null
  },
  setup(__props: any) {



const { isDarkMode } = storeToRefs(useDarkModeStore())
const worldwideUsersCard = homepageCards[HomePageCard.WorldwideUsers]

return { __sfc: true,isDarkMode, worldwideUsersCard, ImageThumbnail }
}

})